<div class="mr-t--md mr-b--md">
    <a class="btn btn-link btn-icon btn-icon--left btn-back"
       *ngIf="!isHome"
       [routerLink]="['/home']">
        {{ 'Back' | translate }}
    </a>
    <div class="box">
        <div class="card card--b2c--box pb-1">
            <div class="card--b2c--box__header">
                <div class="card--b2c--box__header--info">
                    <div class="card--b2c--box__header__title">
                        {{ 'Dynamic Report' | translate }}
                    </div>
                </div>
                <div class="card--b2c--box__header--info search-txt">
                </div>
                <div class="text-xs-right" *ngIf="isHome">
                    <span class="card--b2c--box__header__action">
                        <button type="button" class="btn btn-block pl-3"
                                [routerLink]="['/b2c-patients/dynamic-report']">
                            {{ 'View All' | translate }}
                            <i class="fal fa-light fa-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!currentCluster">
            <div class="dynamic-report-chart">
                <dynamic-report-bubble-chart [data]="clusters" (activeCluster)="activeCluster($event)"></dynamic-report-bubble-chart>
            </div>
        </div>

        <div class="row" *ngIf="currentCluster">
            <div class="dynamic-report-chart">
                <dynamic-report-pie-chart [data]="currentCluster['subClusters']" [color]="currentCluster['color']" [position]="currentCluster['position']" (activeSubCluster)="activeSubCluster($event)" ></dynamic-report-pie-chart>
            </div>
        </div>

        <div class="row" *ngIf="items">
            <div class="col-xs-12">
                <div class="box">
                    <div class="b2c-table--grid coupons">
                        <div class="b2c-table--grid__body coupons__body">
                            <div class="row">
                                <div class="col-xs-12 coupons__column">
                                    <div class="row">
                                        <div *ngFor="let column of tableColumns" class="{{ column[2] }}"
                                                (click)="sortData(column[0]);"
                                                title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                            <span [ngClass]="{'sorted': sortIsActivated && (sortedColumn === column[0]
                                                            || (sortedColumn === 'created_at_sort' && column[0] === 'created_at')),
                                                            'asc': order === 'asc', 'desc': order === 'desc'}">
                                                {{ column[1] | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let item of items
                                        | orderBy : orderField: sortedColumn
                                        | filterText: searchInfo.keyword:'name'
                                        | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)"
                                            class="row">
                                <div class="col-xs-12">
                                    <div class="row">
                                        <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                            <span class="col col--{{column[0]}}">
                                                {{ item[column[0]] }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--pagination-->
    <!-- . -->

    <pagination-component *ngIf="!paginationHidden && !isHome" [(page)]="currentPage"
        [total]="(items | filterText: searchInfo.keyword:'name').length" [perPage]="itemsPerPage"
        [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
        #pagination></pagination-component>
</div>